import Footer from '@/Components/Partials/Footer';
import { publicUrl } from '@/Helpers/general';
import '@/Themes/Default/Styles/fullscreen-layout.scss';

import React from 'react';
import {Link} from "react-router-dom";

const FullscreenLayout = ({ children }) => {
    return (
        <div className="fullscreen-layout">
            <div className="flex flex-column align-items-center justify-content-between h-full">
                <div>&nbsp;</div>

                <div>
                    <Link className="site-logo uppercase-dark-text p-link flex justify-content-center align-items-center" to={publicUrl('home')}>
                        <img style={{marginBottom:"10px"}} src="/img/nightingale-logo.png"/>
                    </Link>
                    {children}
                </div>

                <Footer />
            </div>
        </div>
    );
};

export default FullscreenLayout;
